import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    Hero,
    HeroActions,
    HeroSubtext,
    HeroTitleImage,
    HeroTitleImageWrap,
    PrimaryCta,
    SecondaryCta,
} from './MidnightMigrationScreen.style';
import titleImage from './assets/titleImage.png';
import { midnitePartnerUrls } from './midnitePartnerUrls';

export const MidnightMigrationHeroSection = observer('MidnightMigrationHeroSection', (): JSX.Element => {
    return (
        <Hero>
            <HeroTitleImageWrap>
                <HeroTitleImage
                    alt='We are collaborating with Midnite'
                    imgBase={{ src: titleImage }}
                />
            </HeroTitleImageWrap>
            <HeroSubtext>
                <I18n
                    langKey='account.midnight-migration.hero-subtext'
                    defaultText='Midnite is a trusted partner offering casino & sportsbook, so you can continue playing your favourite games.'
                />
            </HeroSubtext>
            <HeroActions>
                <PrimaryCta
                    dataTest='midnight-migration-cta-casino'
                    to={midnitePartnerUrls.casinoOffer}
                >
                    <I18n
                        langKey='account.midnight-migration.cta-casino-register'
                        defaultText='Casino Players Register'
                    />
                </PrimaryCta>
                <SecondaryCta
                    dataTest='midnight-migration-cta-sports'
                    to={midnitePartnerUrls.sportsOffer}
                >
                    <I18n
                        langKey='account.midnight-migration.cta-sports-register'
                        defaultText='Sports Bettors Register'
                    />
                </SecondaryCta>
            </HeroActions>
        </Hero>
    );
});
